const translations = {
  de: {
    // Nav
    nav_home: 'Startseite',
    nav_about: 'Über uns',
    nav_whitepapers: 'Whitepapers',
    nav_contact: 'Kontakt',
    nav_impressum: 'Impressum',

    // Home - Hero
    hero_badge: 'Database Security Experts',
    hero_title_1: 'Datenbank-Sicherheit',
    hero_title_2: 'auf höchstem Niveau',
    hero_text: 'Wir schützen Ihre Datenbanken vor Angriffen und helfen Ihnen, Ihre wertvollsten Daten zu sichern.',
    hero_btn_contact: 'Kontakt aufnehmen',
    hero_btn_more: 'Mehr erfahren',

    // Home - Services
    services_title: 'Unsere Leistungen',
    services_subtitle: 'Umfassende Sicherheitslösungen für Ihre Datenbankinfrastruktur',
    service_audit_title: 'Security Audits',
    service_audit_text: 'Umfassende Sicherheitsprüfungen Ihrer Datenbankinstanzen und der gesamten Architektur mit detaillierten Berichten.',
    service_consulting_title: 'Consulting',
    service_consulting_text: 'Professionelle Beratung zur Absicherung Ihrer Datenbanken und Anwendungsserver durch erfahrene Experten.',
    service_info_title: 'Informationen',
    service_info_text: 'Präsentationen und Fachartikel zu Datenbanksicherheit, Schwachstellen und Best Practices.',
    service_info_link: 'Präsentationen ansehen →',

    // Home - Stats
    stat_experience: 'Jahre Erfahrung',
    stat_audits: 'Security Audits',
    stat_clients: 'Zufriedene Kunden',

    // Home - CTA
    cta_title: 'Bereit, Ihre Datenbanken zu sichern?',
    cta_text: 'Kontaktieren Sie uns für eine unverbindliche Beratung.',
    cta_btn: 'Jetzt Kontakt aufnehmen',

    // About
    about_title_1: 'Über',
    about_title_2: 'uns',
    about_subtitle: 'Erfahren Sie mehr über Red-Database-Security und unser Team.',
    about_company_title: 'Unser Unternehmen',
    about_company_text: 'Red-Database-Security GmbH ist ein auf Datenbanksicherheit spezialisiertes Unternehmen. Unsere Mission ist es, Datenbankinstallationen, Software und Anwendungen sicherer zu machen und unseren Kunden zu helfen, ihre wertvollsten Daten zu schützen.',
    about_expertise_title: 'Unsere Expertise',
    about_expertise_text: 'Alle unsere Mitarbeiter verfügen über langjährige Erfahrung mit Datenbanktechnologien als Entwickler und Datenbankadministratoren. Wir sind spezialisiert auf Oracle-Sicherheit und bieten umfassende Sicherheitslösungen an.',
    about_services_title: 'Unsere Leistungen',
    about_service_1: 'Security Audits von Datenbankinstanzen und Architekturen',
    about_service_2: 'Sicherheitsberatung für Datenbanken und Anwendungsserver',
    about_service_3: 'Schulungen zu Datenbanksicherheit und Anti-Hacker-Techniken',
    about_service_4: 'Penetrationstests und Schwachstellenanalysen',
    about_ceo_title: 'Geschäftsführung',
    about_ceo_text: 'Alexander Kornbrust — CEO und Gründer der Red-Database-Security GmbH.',
    about_linkedin: 'LinkedIn-Profil',
    about_publication_title: 'Publikation',
    about_publication_text: 'Co-Author des Fachbuchs',
    about_speaker_title: 'Speaker',

    // Contact
    contact_title: 'Kontakt',
    contact_subtitle: 'Wir freuen uns auf Ihre Nachricht.',
    contact_info_title: 'Kontaktdaten',
    contact_address: 'Adresse',
    contact_phone: 'Telefon',
    contact_fax: 'Fax',
    contact_email: 'E-Mail',
    contact_form_title: 'Nachricht senden',
    contact_name: 'Name',
    contact_name_placeholder: 'Ihr Name',
    contact_email_label: 'E-Mail',
    contact_email_placeholder: 'Ihre E-Mail-Adresse',
    contact_subject: 'Betreff',
    contact_subject_placeholder: 'Betreff',
    contact_message: 'Nachricht',
    contact_message_placeholder: 'Ihre Nachricht...',
    contact_send: 'Nachricht senden',

    // Impressum
    impressum_title: 'Impressum',
    impressum_tmg: 'Angaben gemäß § 5 TMG',
    impressum_represented: 'Vertreten durch',
    impressum_contact: 'Kontakt',
    impressum_register: 'Registereintrag',
    impressum_vat: 'Umsatzsteuer-ID',
    impressum_vat_text: 'Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:',
    impressum_responsible: 'Verantwortlich für den Inhalt',
    impressum_disclaimer: 'Haftungsausschluss',
    impressum_content_title: 'Haftung für Inhalte',
    impressum_content_text: 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.',
    impressum_links_title: 'Haftung für Links',
    impressum_links_text: 'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.',
    impressum_copyright_title: 'Urheberrecht',
    impressum_copyright_text: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.',

    // Presentations
    pres_title: 'Präsentationen',
    pres_subtitle: 'Fachartikel und Vorträge zu Oracle- und Datenbanksicherheit.',
    pres_cis_title: 'CIS Benchmarks',
    pres_cis_subtitle: 'Author and Contributor — Download erfordert einen CIS-Account.',
    pres_best_title: 'Best of Oracle Security',
    pres_best_subtitle: 'Jährliche Übersicht der wichtigsten Oracle-Sicherheitsthemen.',
    pres_wp_title: 'Whitepapers',
    pres_wp_subtitle: 'Technische Fachartikel zu spezifischen Sicherheitsthemen.',

    // Footer
    footer_rights: 'Alle Rechte vorbehalten.',
  },

  en: {
    // Nav
    nav_home: 'Home',
    nav_about: 'About',
    nav_whitepapers: 'Whitepapers',
    nav_contact: 'Contact',
    nav_impressum: 'Legal Notice',

    // Home - Hero
    hero_badge: 'Database Security Experts',
    hero_title_1: 'Database Security',
    hero_title_2: 'at the Highest Level',
    hero_text: 'We protect your databases from attacks and help you secure your most valuable data.',
    hero_btn_contact: 'Get in Touch',
    hero_btn_more: 'Learn More',

    // Home - Services
    services_title: 'Our Services',
    services_subtitle: 'Comprehensive security solutions for your database infrastructure',
    service_audit_title: 'Security Audits',
    service_audit_text: 'Comprehensive security assessments of your database instances and overall architecture with detailed reports.',
    service_consulting_title: 'Consulting',
    service_consulting_text: 'Professional consulting to secure your databases and application servers by experienced experts.',
    service_info_title: 'Resources',
    service_info_text: 'Presentations and articles on database security, vulnerabilities and best practices.',
    service_info_link: 'View Presentations →',

    // Home - Stats
    stat_experience: 'Years Experience',
    stat_audits: 'Security Audits',
    stat_clients: 'Satisfied Clients',

    // Home - CTA
    cta_title: 'Ready to Secure Your Databases?',
    cta_text: 'Contact us for a free consultation.',
    cta_btn: 'Get in Touch',

    // About
    about_title_1: 'About',
    about_title_2: 'Us',
    about_subtitle: 'Learn more about Red-Database-Security and our team.',
    about_company_title: 'Our Company',
    about_company_text: 'Red-Database-Security GmbH is a company specialized in database security. Our mission is to make database installations, software and applications more secure and help our customers protect their most valuable data.',
    about_expertise_title: 'Our Expertise',
    about_expertise_text: 'All our employees have many years of experience with database technologies as developers and database administrators. We specialize in Oracle security and offer comprehensive security solutions.',
    about_services_title: 'Our Services',
    about_service_1: 'Security audits of database instances and architectures',
    about_service_2: 'Security consulting for databases and application servers',
    about_service_3: 'Training on database security and anti-hacker techniques',
    about_service_4: 'Penetration testing and vulnerability assessments',
    about_ceo_title: 'Management',
    about_ceo_text: 'Alexander Kornbrust — CEO and founder of Red-Database-Security GmbH.',
    about_linkedin: 'LinkedIn Profile',
    about_publication_title: 'Publication',
    about_publication_text: 'Co-Author of the book',
    about_speaker_title: 'Speaker',

    // Contact
    contact_title: 'Contact',
    contact_subtitle: 'We look forward to hearing from you.',
    contact_info_title: 'Contact Information',
    contact_address: 'Address',
    contact_phone: 'Phone',
    contact_fax: 'Fax',
    contact_email: 'Email',
    contact_form_title: 'Send a Message',
    contact_name: 'Name',
    contact_name_placeholder: 'Your Name',
    contact_email_label: 'Email',
    contact_email_placeholder: 'Your email address',
    contact_subject: 'Subject',
    contact_subject_placeholder: 'Subject',
    contact_message: 'Message',
    contact_message_placeholder: 'Your message...',
    contact_send: 'Send Message',

    // Impressum
    impressum_title: 'Legal Notice',
    impressum_tmg: 'Information pursuant to § 5 TMG',
    impressum_represented: 'Represented by',
    impressum_contact: 'Contact',
    impressum_register: 'Register Entry',
    impressum_vat: 'VAT ID',
    impressum_vat_text: 'VAT identification number pursuant to § 27a of the German VAT Act:',
    impressum_responsible: 'Responsible for Content',
    impressum_disclaimer: 'Disclaimer',
    impressum_content_title: 'Liability for Content',
    impressum_content_text: 'The contents of our pages have been created with the utmost care. However, we cannot guarantee the accuracy, completeness and timeliness of the content.',
    impressum_links_title: 'Liability for Links',
    impressum_links_text: 'Our website contains links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for this third-party content.',
    impressum_copyright_title: 'Copyright',
    impressum_copyright_text: 'The content and works created by the site operators on these pages are subject to German copyright law. The reproduction, editing, distribution and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator.',

    // Presentations
    pres_title: 'Presentations',
    pres_subtitle: 'Articles and talks on Oracle and database security.',
    pres_cis_title: 'CIS Benchmarks',
    pres_cis_subtitle: 'Author and Contributor — Download requires a CIS account.',
    pres_best_title: 'Best of Oracle Security',
    pres_best_subtitle: 'Annual overview of the most important Oracle security topics.',
    pres_wp_title: 'Whitepapers',
    pres_wp_subtitle: 'Technical articles on specific security topics.',

    // Footer
    footer_rights: 'All rights reserved.',
  },
};

export function t(lang, key) {
  return translations[lang]?.[key] || translations.de[key] || key;
}

export default translations;
